const OPERATORS = new Set(['AND', 'OR', 'NOT'])

// Garde les valeurs (mots nus, phrases, valeurs de facette), retire noms de facette, opérateurs et IDs opaques ; un faux positif n'a aucun coût visuel pour le surligneur.
const TOKEN_RE = /[a-zA-Z]+:"([^"]*)"|[a-zA-Z]+:(\S+)|"([^"]*)"|(\S+)/g

export function extractSearchTerms(query: string | undefined | null): string[] {
  if (!query) return []
  const terms = new Set<string>()

  for (const match of query.matchAll(TOKEN_RE)) {
    const [, facetQuotedVal, facetBareVal, phrase, bare] = match

    if (facetQuotedVal !== undefined) {
      addTerm(terms, facetQuotedVal)
      continue
    }
    if (facetBareVal !== undefined) {
      // Deux-points chaînés ("event:afpevent:xxx") = id opaque, on ignore.
      if (facetBareVal.includes(':')) continue
      addTerm(terms, facetBareVal)
      continue
    }
    if (phrase !== undefined) {
      addTerm(terms, phrase)
      continue
    }
    if (bare !== undefined) {
      addBareToken(terms, bare)
    }
  }

  return [...terms]
}

function addBareToken(terms: Set<string>, token: string): void {
  const stripped = token.replace(/^[(]+|[)]+$/g, '')
  if (!stripped) return
  if (OPERATORS.has(stripped.toUpperCase())) return
  // Retire la ponctuation résiduelle mais conserve accents, chiffres et traits d'union.
  const cleaned = stripped.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, '')
  if (cleaned.length < 2) return
  terms.add(cleaned)
}

function addTerm(terms: Set<string>, value: string): void {
  const trimmed = value
    .trim()
    .replace(/^[(]+|[)]+$/g, '')
    .trim()
  if (trimmed.length < 2) return
  if (OPERATORS.has(trimmed.toUpperCase())) return
  terms.add(trimmed)
}
